// extracted by mini-css-extract-plugin
export default {"box":"FilterCity_box__YzfkW","input":"FilterCity_input__dJDA0","boxLoading":"FilterCity_boxLoading__tibv9"};